import { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckmark = forwardRef((props, ref) => {
	return React.createElement(SvgIcon, {
		...props,
		ref
	}, /* @__PURE__ */ _jsx("path", {
		id: "svg_1",
		d: "m15.75,0.75l-10.061,14.371a1.467,1.467 0 0 1 -2.38,0.04l-2.559,-3.413",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		stroke: "currentcolor",
		fill: "none"
	}));
});
export default SvgCheckmark;
